var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSickIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "health-medical-heart-rate--health-beauty-information-data-beat-pulse-monitor-heart-rate-info"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.24285 9.23571C2.33571 3.96428 8.82857 -8.60018e-06 15 7.00713C23.8071 -3.08572 33.2143 9.42856 26.8286 15.8786L15 26.7857L8.07857 20.3571",
    stroke: "#1E85A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.07143 15H6.42857L9.64286 10.7143L13.9286 18.2143L17.1429 13.9286H20.3571",
    stroke: "#1E85A7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSickIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sick_icon.4cb159a8b1f5e4bae2585adb5703c58f.svg";